import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICmsComponent, NICmsContentComponent } from '@icms/core/content';
import { ProductReviewsComponent } from '../../product-reviews/product-reviews.component';
import { ProductViewLayoutComponent } from '../../view-layout/product-view-layout.component';
import { AbstractProductCmsComponent } from '../abstract-product-cms.component';
export namespace NCmsProductReviews {
    export interface IComponentData extends NICmsContentComponent.IData {}
}
@Component({
    selector: 'cms-product-reviews',
    templateUrl: './cms-product-reviews.html',
    standalone: true,
    imports: [ProductReviewsComponent],
    providers: [ProductViewLayoutComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsProductReviewsComponent>({
    id: 'product-reviews',
    name: 'Product reviews',
    tags: ['product page', 'reviews'],
    onDemandOnly: true,
    fields: []
})
export class CmsProductReviewsComponent extends AbstractProductCmsComponent<NCmsProductReviews.IComponentData> {
    /**
     * Retrieves reviews qty
     */
    get qty(): number {
        return this.parent?.data?.reviews?.count || 0;
    }
}
